import { AfterViewInit, Component, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ApCookieConsentService } from '@ap/cookie-consent';

import content from './huismap.content.json';

/**
 * @module HuismapModule
 *
 * @ngdoc component
 * @name HuismapComponent
 *
 * @description
 *
 */
@Component({
    selector: 'huismap',
    templateUrl: './huismap.component.html',
    styleUrls: ['./huismap.component.scss'],
    standalone: false
})
export class HuismapComponent implements OnInit, AfterViewInit {
    constructor(
        private readonly contentService: ApContentService,
        private readonly cookieService: ApCookieConsentService
    ) {}

    ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    ngAfterViewInit(): void {
        const consentLevels = this.cookieService.getConsent();
        if (consentLevels.empty) {
            this.cookieService.open();
        }
    }
}
